import SvgControlDefault from '../../lib/jin/svgchartlib/02_PageComponents/01_ModalContainer/includes/primitives/Data'

export default SvgControlDefault